import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    searchParams: {
        id: "",
        type: "",
        method: ""
    },
}

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setPaymentSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.searchParams = { ...state.searchParams, [key]: value }
        }
    },
});

export const { setPaymentSearchParamsAction } = paymentSlice.actions;
export default paymentSlice;